<template>
  <div class="ma-6">
    <v-col>
        <v-row style="align-items: baseline;">
            BAB: <v-text-field style="text-align:center; max-width:50px; text-align-last: center;" single-line class="ml-1" v-model="bab" type="number" dense></v-text-field>
        </v-row>
        <v-row>
            <v-col>
                bonus attack:
                {{Math.floor(bab/4)+1}}
            </v-col>
             <v-col>
                off-hand damage: 
                {{Math.floor(bab/4)+1}}
            </v-col>
            <v-col>
                main-hand damage: 
                {{2 * (Math.floor(bab/4)+1)}}
            </v-col>
            <v-col>
                1.5x damage: 
                {{(3 * (Math.floor(bab/4)+1))}}
            </v-col>
        </v-row>
        <br/><br/><br/><br/>
        <v-row style="align-items: baseline;">
            HP: 
            <v-text-field style="text-align:center; max-width:50px; text-align-last: center;" single-line class="ml-1" v-model="hdAmount" type="number" dense></v-text-field>D<v-text-field style="text-align:center; max-width:50px; text-align-last: center;" single-line class="ml-1" v-model="hdSize" type="number" dense></v-text-field>+ <v-text-field style="text-align:center; max-width:50px; text-align-last: center;" single-line class="ml-1" v-model="hpPlus" type="number" dense></v-text-field>            
        </v-row>
        <br/><br/>Total: {{hdSize * hdAmount + parseInt(hpPlus)}}
        <br/><br/><br/><br/>
        <v-row>
          ATK String: <v-text-field style="text-align:center; max-width:300px; text-align-last: center;" single-line class="ml-1" v-model="atkString" dense></v-text-field> mods:+ <v-text-field style="text-align:center; max-width:50px; text-align-last: center;" single-line class="ml-1" v-model="atkMod" type="number" dense></v-text-field> Crit:<v-text-field style="text-align:center; max-width:50px; text-align-last: center;" single-line class="ml-1" v-model="crit" type="number" dense></v-text-field> 
        </v-row><br/><br/>
        <v-row>
          DMG String<br/><br/><v-text-field style="text-align:center; max-width:300px; text-align-last: center;" single-line class="ml-1" v-model="dmgString" dense></v-text-field>
        </v-row>
        <v-btn @click="returnString">calc</v-btn><br/><br/>
        Last:<br/><br/><span style="white-space: pre-wrap">{{attackString}}</span>
    </v-col>

   
  </div>     
</template>
<script>
import {
    VTextField,
    VRow,
    VCol,
    VBtn,
} from "vuetify/lib";
export default {
  components: {
    VTextField,
    VRow,
    VCol,
    VBtn,
  },
  data(){
    return{
        bab:0,
        hdSize:0,
        hdAmount:0,
        hpPlus:0,
        atkString:"",
        atkMod:0,
        crit:20,
        dmgString:"",
        attackString:"",
    }
  },
  methods:{
    returnString(){
      let string = `%NEWLINE%`
      let atks = this.atkString.split("/")
      console.log("atks?", atks)
      atks.forEach(atk=>{
        let atkNum = parseInt(atk) + parseInt(this.atkMod)
        string += `[[1d20cs>` + this.crit + `+`+ atkNum + `]]`
      })
      string += `\n`
      atks.forEach(()=>{
        string += `[[` + this.dmgString + `]]+`
      })
      this.attackString = string
    }
  }
  
}
</script>
<style scoped>
table, th, td {
  border:1px solid black;
}
</style>